import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCarTab = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8413 1.88672H6.1613C4.5013 1.88672 4.13464 2.71339 3.9213 3.72672L3.16797 7.33339H13.8346L13.0813 3.72672C12.868 2.71339 12.5013 1.88672 10.8413 1.88672Z",
			stroke: "",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1618 13.213C15.2351 13.993 14.6084 14.6663 13.8084 14.6663H12.5551C11.8351 14.6663 11.7351 14.3597 11.6084 13.9797L11.4751 13.5797C11.2884 13.033 11.1684 12.6663 10.2084 12.6663H6.79511C5.83511 12.6663 5.69511 13.0797 5.52844 13.5797L5.39511 13.9797C5.26844 14.3597 5.16844 14.6663 4.44844 14.6663H3.19511C2.39511 14.6663 1.76844 13.993 1.84178 13.213L2.21511 9.15301C2.30844 8.15301 2.50178 7.33301 4.24844 7.33301H12.7551C14.5018 7.33301 14.6951 8.15301 14.7884 9.15301L15.1618 13.213Z",
			stroke: "",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.16667 5.33301H2.5",
			stroke: "",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4987 5.33301H13.832",
			stroke: "",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 2V3.33333",
			stroke: "",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 3.33301H9.5",
			stroke: "",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 10H6.5",
			stroke: "",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 10H12.5",
			stroke: "",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCarTab;
